const config = {
  environment: process.env.ENVIRONMENT || 'local',
  baseApiUrl: process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api',
  joinUrl: process.env.VUE_APP_JOIN_URL || 'http://enrollnow.local:3000/join',
  addUrl: process.env.VUE_APP_JOIN_URL?.replace('/join', '') || 'http://enrollnow.local:3000',
  rollbar: {
    enabled: process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN !== undefined,
    accessToken: process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN
  }
};
if(config.environment === 'local') {
  config.baseApiUrl = config.baseApiUrl + '/join/v1'
}
export default config;
